// @flow

import { createUpdateResourceSettings } from 'api'

import { createReminder } from '@/queries/reminders/services/mutateReminders'
import { updateReminderById } from '@/queries/reminders/services/updateReminderById'

type Context = {
  values: any,
  onValidate: (values: any) => void,
  onSave: (values: any) => void,
}

type ExtraContexts = {
  [string]: Context,
}

export const contextNames = {
  customNotifications: 'custom-notifications',
}

export async function validateExtraContexts(extraContexts: ExtraContexts) {
  for (const contextName of Object.keys(extraContexts)) {
    const context = extraContexts[contextName]

    if (!context) continue

    if (context.onValidate && typeof context.onValidate === 'function') {
      await context.onValidate(context.values || null)
    }
  }
}

export async function saveExtraContexts(extraContexts: ExtraContexts) {
  for (const contextName of Object.keys(extraContexts)) {
    const context = extraContexts[contextName]

    if (!context) continue

    const onSave = extraContextSubmits[contextName]

    if (onSave) {
      await onSave(context.values || null)
    }
  }
}

export const saveReminder = async (values: any) => {
  if (!values) return
  const data = {
    id: values.resourceId,
    use_custom_messaging: values.useCustomInvite,
    email_subject: values.emailSubject,
    email_content: values.emailMessage,
    sms_content: values.textMessage,
  }
  if (values.useReminderInvite) {
    const reminderData = {
      id: values?.id_reminder,
      form: values?.form,
      packet: values?.packet,
      document: values?.document,
      enabled: true,
      reminder_condition: values?.reminder_condition,
      reminder_days: values?.reminder_days,
      email_subject: values?.email_reminder_subject,
      email_body: values?.email_body,
      sms_body: values?.sms_body,
    }

    if (values?.id_reminder) {
      await updateReminderById(reminderData)
    }
    if (!values?.id_reminder) {
      await createReminder(reminderData)
    }
  }
  await createUpdateResourceSettings(values.resourceId, data)
}

const extraContextSubmits = {
  [contextNames?.customNotifications]: async (values: any) =>
    await saveReminder(values),
}
